module.exports = __webpack_public_path__ + "img/accuaspects.bc122da5.png";